import { formField } from '../../utils/decorators'
import { Lists } from '../../utils/lists'
import { Strings } from '../../utils/strings'
import { Source, UUID } from '../types'
import { CMSObject } from './__CMSObject'
import { FieldType } from './__ModelInfo'

export class QualificationGroup extends CMSObject {
	public static title = 'Qualification group'
	public static autoPublish = true
	public name: string

	@formField({
		fieldtype: FieldType.Text,
		flags: { private: false, hidden: false }
	})
	public id: number
	public business_stream: UUID[]
	public source: Source

	constructor(item: any = {}) {
		super(item)

		this.name = Strings.default(item.name)
		this.id = item.id || 0
		this.business_stream = Lists.default(item.business_stream)
		this.source = Strings.default(item.source) as Source
	}
}
